import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

@Injectable()
export class MessageServiceProvider {

  loader = null;
  constructor(public alertCtrl: AlertController, public loadingController: LoadingController, public toastController: ToastController) {
  }
  hideLoading() {
    this.loader.dismiss();
  }
  showLoading(msg) {
    this.loader = this.loadingController.create({
      content: msg,
    });
    this.loader.present();
  }
  alert(title, msg, fb = null, backdropdismiss=true) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      enableBackdropDismiss: backdropdismiss,
      buttons: [{
        text: 'OK',
        handler: data => {
          if (fb != null) {
            fb();
          }
        }
      }]
    });
    alert.present();

    return alert;
  }
  charactercreate(title, msg, fb = null) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [{
        text: 'Create',
        handler: data => {
          if (fb != null) {
            fb();
          }
        }
      }]
    });
    alert.present();

    return alert;
  }
  confirm(title, msg, fb = null,txtCancel="Cancel",txtOK="OK") {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [{
        text: txtCancel,
        handler: data => {
          if (fb != null) {
            fb(null);
          }
        } }, {
        text: txtOK,
        handler: data => {
          if (fb != null) {
            fb(true);
          }
        }
      }]
    });
    alert.present();
  }
  confirmchange(title, msg, fb = null) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [{ text: 'Cancel' }, {
        text: 'Save',
        handler: data => {
          if (fb != null) {
            fb(true);
          }
        }
      },
      {
        text: 'Undo changes',
        handler: data => {
          if (fb != null) {
            fb(false);
          }
        }
      }]
    });
    alert.present();
  }
  toast(msg,pos="bottom") {
    let toast = this.toastController.create({
      message: msg,
      duration: 3000,
      position:pos
    });
    toast.present();
  }
  prompt(title, msg, fb, value: string = "", placeholder: string = "Title", type: string = "text", backdropdismiss: boolean = true, showcancel: boolean = true) {
    let prompt = this.alertCtrl.create({
      title: title,
      message: msg,
      enableBackdropDismiss: backdropdismiss,
      inputs: [
        {
          value: value,
          name: 'title',
          placeholder: placeholder,
          type: type
        },
      ],
      buttons: showcancel ? [
        {
          text: 'Cancel',
          handler: data => {
            fb(false);
          }
        },
        {
          text: 'OK',
          handler: data => {
            if (fb != null) {
              fb(data.title);
            }
          }
        }
      ] : [{
        text: 'OK',
        handler: data => {
          if (fb != null) {
            fb(data.title);
          }
        }
      }]
    });
    prompt.present();
  }

  checkboxes(title, options, fb) {
    let alert = this.alertCtrl.create();
    alert.setTitle(title);

    for (let option of options) {
      alert.addInput({
        type: 'checkbox',
        label: option.label,
        value: option.value,
        checked: option.checked
      });
    }


    alert.addButton('Cancel');
    alert.addButton({
      text: 'Okay',
      handler: data => {
        if (fb != null) {
          fb();
        }
      }
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/message-service/message-service.ts